import Cookies from 'js-cookie';
import UrlHelper from '../Helpers/Url'

const post = async (url, body) => {
    var headers = {
        'Content-Type': 'application/json',
        'X-Token': Cookies.get('token')
    };

    return fetch(`${url}`, {
        method: 'POST',
        mode: 'cors',
        headers,
        body: JSON.stringify(body),
    })
        .then(handle)
}

const get = (url, params) => {
    var headers = {
        'Content-Type': 'application/json',
        'X-Token': Cookies.get('token')
    };
    let urlObject = new URL(url);

    if(params){
        urlObject.search = new URLSearchParams(params).toString();
    }

    return fetch(`${urlObject}`, {
        method: 'GET',
        mode: 'cors',
        headers,
    })
        .then(handle)
}

const getPdf = (url, params) => {
    let urlObject = new URL(url);

    if(params){
        urlObject.search = new URLSearchParams(params).toString();
    }

    return fetch(`${urlObject}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/pdf',
            'X-Token': Cookies.get('token')
        },
    })
}


const handle = (response) => {
    if (response.ok) {
        return response.json();
    }
    else {
        return new Promise((resolve, reject) => {
            let message;
            switch (response.status) {
                case 401:
                    UrlHelper.RedirectToLoginPreserveCallback();
                    message = `Se requiere autenticación. Por favor ingrese sus credenciales nuevamente - (status code: ${response.status})`;
                    break;
                case 402:
                    break;
                case 403:
                    message = `No posee los permisos necesarios para acceder al recurso solicitado. Por favor ingrese sus credenciales nuevamente - (status code: ${response.status})`;
                    break;
                case 404:
                    message = `No existe el recurso solicitado. Por favor intentelo nuevamente más tarde - (status code: ${response.status})`;
                    break;
                case 400:
                case 500:
                case 'parsererror':
                case 'timeout':
                case 'abort':
                case 0:
                default:
                    message = "Ocurrió un error inesperado. Por favor intentelo nuevamente más tarde.";
            }
            reject(message);
        })
    }
}




export default { post , get, getPdf };



